
import { ContractorSkeleton } from "./contractors-list/ContractorSkeleton";

interface LoadingStateProps {
  message?: string;
}

export const LoadingState = ({ message = "Loading..." }: LoadingStateProps) => {
  return (
    <>
      <p className="text-center text-muted-foreground mb-8">{message}</p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {Array.from({ length: 8 }).map((_, index) => (
          <ContractorSkeleton key={index} />
        ))}
      </div>
    </>
  );
};
